export const SPANISH_KEY_TRANSLATION = 'language.spanish'
export const ENGLISH_KEY_TRANSLATION = 'language.english'
